import React, { useEffect, useImperativeHandle, useState } from 'react';
import { useSelector } from 'react-redux';
import { mageConfigSelector } from '@@Redux/selectors/config.selectors';
import Input from '@@Components/Input/Input';
import { PriceCurrencySign, PriceFilterDivider, PriceFilterInputWrapper, PriceFilterWrapper, MultiRangeContainer, RangeInput, Slider, SliderRange, SliderTrack } from '@@Components/PriceFilter/styled';
export const PriceFilter = React.forwardRef(({ value = [], min = 0, max = 1, step, slider }, ref) => {
    var _a, _b, _c, _d;
    const config = useSelector(mageConfigSelector);
    const [price, setPrice] = useState(value);
    const [inputsPrice, setInputsPrice] = useState(value);
    const onPriceFromChange = (priceFrom) => {
        const [from, to] = inputsPrice;
        const newPrice = [priceFrom, to || null];
        setInputsPrice(newPrice);
    };
    const onPriceToChange = (priceTo) => {
        const [from, to] = inputsPrice;
        const newPrice = [from || 0, priceTo];
        setInputsPrice(newPrice);
    };
    const getValidatedPrice = (from, to) => {
        let newFrom = from;
        let newTo = to;
        if (from < min || from > max)
            newFrom = min;
        if (to > max || to < min)
            newTo = max;
        if (from >= to) {
            newFrom = min;
            newTo = max;
        }
        return [newFrom, newTo];
    };
    const getPercentage = (value, fromValue) => (value / fromValue) * 100;
    const onChangeHandle = (event, type) => {
        if (type === 1) {
            const value = Math.min(Number(event.target.value), price[1] - 1);
            const [from, to] = price;
            const newPrice = [value, to];
            setInputsPrice(newPrice);
        }
        if (type === 2) {
            const value = Math.max(Number(event.target.value), price[0] + 1);
            const [from, to] = price;
            const newPrice = [from, value];
            setInputsPrice(newPrice);
        }
    };
    useEffect(() => {
        if (value instanceof Array) {
            const [from, to] = value;
            const [newFrom, newTo] = getValidatedPrice(from, to);
            setPrice([newFrom, newTo]);
            setInputsPrice([newFrom, newTo]);
        }
        else {
            const newPrice = [value];
            setPrice(newPrice);
        }
    }, [value]);
    useEffect(() => setPrice(getValidatedPrice(inputsPrice[0], inputsPrice[1])), [inputsPrice]);
    useImperativeHandle(ref, () => ({
        getPrice: () => price
    }), [price]);
    return (React.createElement("div", null,
        React.createElement(PriceFilterWrapper, null,
            React.createElement(PriceFilterInputWrapper, null,
                React.createElement(Input, { type: "number", value: (_a = inputsPrice[0]) === null || _a === void 0 ? void 0 : _a.toString(), onChange: (e) => onPriceFromChange(Number(e.target.value)) }),
                React.createElement(PriceCurrencySign, null, (_b = config === null || config === void 0 ? void 0 : config.i18n) === null || _b === void 0 ? void 0 : _b.currency_sign)),
            React.createElement(PriceFilterDivider, null),
            React.createElement(PriceFilterInputWrapper, null,
                React.createElement(Input, { type: "number", value: (_c = inputsPrice[1]) === null || _c === void 0 ? void 0 : _c.toString(), onChange: (e) => onPriceToChange(Number(e.target.value)) }),
                React.createElement(PriceCurrencySign, null, (_d = config === null || config === void 0 ? void 0 : config.i18n) === null || _d === void 0 ? void 0 : _d.currency_sign))),
        slider && (React.createElement(MultiRangeContainer, null,
            React.createElement(RangeInput, { zIndex: price[0] > (max - 2) ? 5 : 3, type: 'range', value: price[0], min: min, max: max, step: step, onChange: (event) => onChangeHandle(event, 1) }),
            React.createElement(RangeInput, { zIndex: 4, type: 'range', value: price[1], min: min, max: max, step: step, onChange: (event) => onChangeHandle(event, 2) }),
            React.createElement(Slider, null,
                React.createElement(SliderTrack, null),
                React.createElement(SliderRange, { left: getPercentage((price[0] - min), max - min), width: getPercentage((price[1] - price[0]), max - min) }))))));
});
